import { render, staticRenderFns } from "./UploadSection.vue?vue&type=template&id=f542f320&scoped=true"
import script from "./UploadSection.ts?vue&type=script&lang=ts&external"
export * from "./UploadSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f542f320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f542f320')) {
      api.createRecord('f542f320', component.options)
    } else {
      api.reload('f542f320', component.options)
    }
    module.hot.accept("./UploadSection.vue?vue&type=template&id=f542f320&scoped=true", function () {
      api.rerender('f542f320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Uploader/components/UploadSection/UploadSection.vue"
export default component.exports